import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_CZ.json';
import recipes from './COOKING_RECIPES_CZ.json';
import videos from './COOKING_VIDEOS_CZ.json';

export const COOKING_DATA_CZ: ServiceData = {
  articles,
  recipes,
  videos,
};
